// import React, { useState, useRef } from "react";
// import {
//   Box,
//   IconButton,
//   TextField,
//   Paper,
//   Fade,
//   List,
//   ListItem,
//   ListItemText,
//   Typography,
//   Divider,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from "@mui/icons-material/Close";
// import LaunchIcon from "@mui/icons-material/Launch";
// import { useGlobalSearch } from "./searchHooks";
// import { useNavigate } from "react-router-dom";


// export const MainSearchBar = () => {
//   const [query, setQuery] = useState("");
//   const [isOpen, setIsOpen] = useState(false);
//   const [showSearch, setShowSearch] = useState(false);
//   const { searchResults, isSearching, searchData, clearResults } =
//     useGlobalSearch();
//   const navigate = useNavigate();
//   const iconRef = useRef(null);

//   const handleSearch = (value) => {
//     setQuery(value);
//     if (value.trim()) {
//       searchData(value);
//       setIsOpen(true);
//     } else {
//       clearResults();
//       setIsOpen(false);
//     }
//   };

//   const handleInternalLinkClick = (path) => {
//     navigate(path);
//     setQuery("");
//     setIsOpen(false);
//     clearResults();
//     setShowSearch(false);
//   };

//   const handleClose = () => {
//     setIsOpen(false);
//     setQuery("");
//     clearResults();
//     setShowSearch(false);
//   };

//   const isExternalLink = (result) => {
//     return result.external || result.path.startsWith("http");
//   };

//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "flex-end",
//           alignItems: "center",
//           height: "64px",
//         }}
//       >
//         <IconButton
//           ref={iconRef}
//           onClick={() => setShowSearch(true)}
//           color="inherit"
//           size="large"
//         >
//           <SearchIcon
//             sx={{
//               color: "white",
//               animation: "zoomInOut 2s ease-in-out infinite",
//               "@keyframes zoomInOut": {
//                 "0%, 100%": {
//                   transform: "scale(1)",
//                 },
//                 "50%": {
//                   transform: "scale(1.5)",
//                 },
//               },
//             }}
//           />
//         </IconButton>
//       </Box>

//       {showSearch && (
//         <Box
//           sx={{
//             position: "absolute",
//             right: 32, // Adjust according to the navbar padding
//             top: 72, // 64 (navbar height) + 8 (spacing)
//             width: 340,
//             zIndex: 1300,
//           }}
//         >
//           <TextField
//             fullWidth
//             size="small"
//             autoFocus
//             placeholder="Search routes..."
//             value={query}
//             onChange={(e) => handleSearch(e.target.value)}
//             onFocus={() => query.trim() && setIsOpen(true)}
//             InputProps={{
//               startAdornment: (
//                 <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
//               ),
//               endAdornment: query && (
//                 <IconButton size="small" onClick={handleClose}>
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               ),
//             }}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 backgroundColor: "white",
//                 borderRadius: 2,
//               },
//             }}
//           />
//           {isOpen && (
//             <Fade in={isOpen}>
//               <Paper
//                 sx={{
//                   mt: 1,
//                   maxHeight: 400,
//                   overflow: "auto",
//                   boxShadow: 3,
//                   p: 1,
//                 }}
//               >
//                 {isSearching ? (
//                   <ListItem>
//                     <ListItemText primary="Searching..." />
//                   </ListItem>
//                 ) : searchResults.length > 0 ? (
//                   <List dense>
//                     <ListItem>
//                       <Typography variant="subtitle2" color="text.secondary">
//                         Found {searchResults.length} results
//                       </Typography>
//                     </ListItem>
//                     <Divider />
//                     {searchResults.map((result, index) => (
//                       <ListItem
//                         key={index}
//                         component={isExternalLink(result) ? "a" : "div"}
//                         href={isExternalLink(result) ? result.path : undefined}
//                         target={isExternalLink(result) ? "_blank" : undefined}
//                         rel={
//                           isExternalLink(result)
//                             ? "noopener noreferrer"
//                             : undefined
//                         }
//                         button={!isExternalLink(result)}
//                         onClick={
//                           !isExternalLink(result)
//                             ? () => handleInternalLinkClick(result.path)
//                             : undefined
//                         }
//                         sx={{
//                           "&:hover": {
//                             backgroundColor: "action.hover",
//                           },
//                           textDecoration: "none",
//                           color: "inherit",
//                         }}
//                       >
//                         <ListItemText
//                           primary={
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                               {result.title}
//                               {isExternalLink(result) && (
//                                 <LaunchIcon
//                                   sx={{
//                                     fontSize: 14,
//                                     ml: 1,
//                                     color: "text.secondary",
//                                   }}
//                                 />
//                               )}
//                             </Box>
//                           }
//                           secondary={`${result.category} • ${result.path}`}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 ) : query.length > 0 ? (
//                   <ListItem>
//                     <ListItemText
//                       primary="No results found"
//                       secondary="Try different keywords"
//                     />
//                   </ListItem>
//                 ) : null}
//               </Paper>
//             </Fade>
//           )}
//         </Box>
//       )}
//     </>
//   );
// };


import React, { useState, useRef } from "react";
import {
  Box,
  IconButton,
  TextField,
  Paper,
  Fade,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  Chip,
  Tabs,
  Tab,
  Badge,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import LaunchIcon from "@mui/icons-material/Launch";
import ArticleIcon from "@mui/icons-material/Article";
import RouteIcon from "@mui/icons-material/Route";
import { useGlobalSearch } from "./searchHooks";
import { useNavigate } from "react-router-dom";

export const MainSearchBar = () => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const { searchResults, isSearching, searchData, clearResults } = useGlobalSearch();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const handleSearch = (value) => {
    setQuery(value);
    if (value.trim()) {
      searchData(value);
      setIsOpen(true);
    } else {
      clearResults();
      setIsOpen(false);
    }
  };

  const handleSearchSubmit = () => {
    if (query.trim()) {
      searchData(query);
      setIsOpen(true);
    }
  };

  const handleInternalLinkClick = (path) => {
    navigate(path);
    setQuery("");
    setIsOpen(false);
    clearResults();
    setShowSearch(false);
  };

  const handleContentClick = (result) => {
    if (result.link && (result.external || result.link.startsWith("http"))) {
      window.open(result.link, "_blank", "noopener,noreferrer");
    } else {
      navigate(result.path);
    }
    setQuery("");
    setIsOpen(false);
    clearResults();
    setShowSearch(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setQuery("");
    clearResults();
    setShowSearch(false);
  };

  const isExternalLink = (result) => {
    return result.external || result.path.startsWith("http");
  };

  const getResultIcon = (result) => {
    if (result.type === 'content') {
      return <ArticleIcon sx={{ fontSize: 16, mr: 1, color: "primary.main" }} />;
    }
    return <RouteIcon sx={{ fontSize: 16, mr: 1, color: "secondary.main" }} />;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString('en-GB');
    } catch {
      return dateString;
    }
  };

  // Group results by category for better organization
  const groupedResults = searchResults.reduce((groups, result) => {
    const category = result.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(result);
    return groups;
  }, {});

  const getCategoryColor = (category) => {
    const colors = {
      // About Section
      'Government Orders': '#1976d2',
      'Financial Establishments': '#2e7d32',
      'Assigned Financial Establishments': '#388e3c',
      'Calendar Events': '#0288d1',
      'Department Contacts': '#0097a7',
      'About': '#1976d2',
      
      // Legal Section
      'Court Cases': '#ed6c02',
      'High Court Cases': '#d32f2f',
      'Supreme Court Cases': '#7b1fa2',
      'Key Judgements': '#ff9800',
      'Legal Team': '#00796b',
      'Legal Opinions': '#5d4037',
      'Legal Research': '#388e3c',
      'Legal Queries': '#f57c00',
      'KPID Act': '#c2185b',
      'BUDS Act': '#ad1457',
      'Other State PIDFE': '#6a1b9a',
      'Other Relevant Acts': '#8e24aa',
      'Comparison of Acts': '#9c27b0',
      'SOP': '#ab47bc',
      'Scam News': '#e91e63',
      'FAQs': '#ec407a',
      'Legal': '#2e7d32',
      
      // Notifications Section
      'Tenders': '#9c27b0',
      'Auctions': '#e91e63',
      'Advertisements': '#2196f3',
      'Circulars & Notifications': '#009688',
      'Office Orders': '#00acc1',
      'Manuals & Videos': '#26c6da',
      'Depositor Information': '#4dd0e1',
      'High Court Orders': '#ff5722',
      'Supreme Court Orders': '#f4511e',
      'Other State Court Orders': '#ff7043',
      'Notifications': '#ed6c02',
      
      // Quick Links & Others
      'Quick Links': '#ffa000',
      'RTI': '#ff8f00',
      'Account': '#f57c00',
      'Claims': '#ffb300',
      'Data': '#43a047',
      'Contact': '#00897b',
      'Main': '#3949ab',
      'News': '#d81b60'
    };
    return colors[category] || '#666666';
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          height: "64px",
        }}
      >
        <IconButton
          onClick={() => setShowSearch(true)}
          color="inherit"
          size="large"
        >
          <SearchIcon
            sx={{
              color: "white",
              animation: "zoomInOut 2s ease-in-out infinite",
              "@keyframes zoomInOut": {
                "0%, 100%": {
                  transform: "scale(1)",
                },
                "50%": {
                  transform: "scale(1.5)",
                },
              },
            }}
          />
        </IconButton>
      </Box>

      {showSearch && (
        <Box
          sx={{
            position: "absolute",
            right: 32,
            top: 72,
            width: 600,
            zIndex: 1300,
          }}
        >
          <TextField
            ref={inputRef}
            fullWidth
            size="small"
            autoFocus
            placeholder="Search everything: government orders, court cases, tenders, financial establishments, legal documents, contacts..."
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearchSubmit()}
            onFocus={() => query.trim() && setIsOpen(true)}
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
              ),
              endAdornment: query && (
                <IconButton size="small" onClick={handleClose}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: 2,
                fontSize: "0.9rem",
              },
            }}
          />
          
          {isOpen && (
            <Fade in={isOpen}>
              <Paper
                sx={{
                  mt: 1,
                  maxHeight: 600,
                  overflow: "auto",
                  boxShadow: 3,
                  p: 0,
                }}
              >
                {/* Tabs for Search Results */}
                <Tabs
                  value={activeTab}
                  onChange={(e, newValue) => setActiveTab(newValue)}
                  sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    minHeight: '48px',
                    '& .MuiTab-root': {
                      minHeight: '48px',
                      fontSize: '0.75rem',
                    }
                  }}
                >
                  <Tab 
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <SearchIcon sx={{ fontSize: 16, mr: 0.5 }} />
                        Results {searchResults.length > 0 && `(${searchResults.length})`}
                      </Box>
                    } 
                  />
                </Tabs> 

                {/* Search Results Tab */}
                <>
                  {isSearching ? (
                    <ListItem>
                      <ListItemText 
                        primary="Searching..." 
                        secondary="Scanning through all routes and database content across 30+ categories..."
                      />
                    </ListItem>
                  ) : searchResults.length > 0 ? (
                    <Box>
                      <ListItem sx={{ backgroundColor: "grey.50", py: 1 }}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Found {searchResults.length} results across {Object.keys(groupedResults).length} categories
                        </Typography>
                      </ListItem>
                      <Divider />
                      
                      {Object.entries(groupedResults).map(([category, categoryResults]) => (
                        <Box key={category}>
                          <ListItem sx={{ backgroundColor: "grey.100", py: 0.5 }}>
                            <Chip
                              label={`${category} (${categoryResults.length})`}
                              size="small"
                              sx={{
                                backgroundColor: getCategoryColor(category),
                                color: 'white',
                                fontSize: '0.7rem',
                                height: '24px'
                              }}
                            />
                          </ListItem>
                          {categoryResults.map((result, index) => (
                            <ListItem
                              key={`${result.type}-${category}-${index}`}
                              component={isExternalLink(result) ? "a" : "div"}
                              href={isExternalLink(result) ? result.path : undefined}
                              target={isExternalLink(result) ? "_blank" : undefined}
                              rel={isExternalLink(result) ? "noopener noreferrer" : undefined}
                              button={!isExternalLink(result) && result.type === 'route'}
                              onClick={
                                result.type === 'content' 
                                  ? () => handleContentClick(result)
                                  : !isExternalLink(result) && result.type === 'route'
                                  ? () => handleInternalLinkClick(result.path)
                                  : undefined
                              }
                              sx={{
                                "&:hover": {
                                  backgroundColor: result.type === 'content' ? 'primary.50' : 'grey.50',
                                },
                                textDecoration: "none",
                                color: "inherit",
                                borderLeft: `4px solid ${getCategoryColor(category)}`,
                                borderBottom: "1px solid",
                                borderBottomColor: "divider",
                                py: 1.5,
                                pl: 2,
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
                                {getResultIcon(result)}
                                <Box sx={{ flex: 1 }}>
                                  <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                                    <Typography 
                                      variant="subtitle2" 
                                      sx={{ 
                                        fontWeight: result.type === 'content' ? 600 : 500,
                                        lineHeight: 1.2
                                      }}
                                    >
                                      {result.title}
                                    </Typography>
                                    {isExternalLink(result) && (
                                      <LaunchIcon
                                        sx={{
                                          fontSize: 14,
                                          ml: 1,
                                          color: "text.secondary",
                                        }}
                                      />
                                    )}
                                  </Box>
                                  
                                  <Box sx={{ display: "flex", alignItems: "center", mb: 0.5, flexWrap: 'wrap', gap: 0.5 }}>
                                    <Chip
                                      label={result.type === 'content' ? 'Content' : 'Route'}
                                      size="small"
                                      variant="outlined"
                                      sx={{ fontSize: '0.6rem', height: '20px' }}
                                    />
                                    {result.date && (
                                      <Chip
                                        label={formatDate(result.date)}
                                        size="small"
                                        sx={{ 
                                          fontSize: '0.6rem', 
                                          height: '20px',
                                          backgroundColor: 'grey.200'
                                        }}
                                      />
                                    )}
                                  </Box>

                                  {result.description && (
                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3, fontSize: '0.8rem' }}>
                                      {result.description}
                                    </Typography>
                                  )}

                                  <Typography variant="caption" color="primary" sx={{ fontStyle: 'italic', fontSize: '0.7rem' }}>
                                    {result.type === 'content' ? 'Click to view details' : 'Click to navigate'}
                                  </Typography>
                                </Box>
                              </Box>
                            </ListItem>
                          ))}
                        </Box>
                      ))}
                    </Box>
                  ) : query.length > 0 ? (
                    <ListItem>
                      <ListItemText
                        primary="No results found"
                        secondary="Try different keywords or check your search terms"
                      />
                    </ListItem>
                  ) : null}
                </>
              </Paper>
            </Fade>
          )}
        </Box>
      )}
    </>
  );
};